const RANDOM_HOSTING = 'https://www.mobile-app.com';
const MobileRoutesEnum = {
    Login: `${RANDOM_HOSTING}/popup/login`,
    Register: `${RANDOM_HOSTING}/popup/registration`,
    CasinoBonus: `${RANDOM_HOSTING}/popup/casinobonuses`,
    SportBonus: `${RANDOM_HOSTING}/popup/sportbonuses`,
    Cashier: `${RANDOM_HOSTING}/popup/cashier`,
    Casino: `${RANDOM_HOSTING}/casino-lobby/All`,
    Sport: `${RANDOM_HOSTING}/sport`,
    TournamentGameLaunch: `${RANDOM_HOSTING}/tournament/game-launch`,
}

Object.freeze(MobileRoutesEnum);

export default MobileRoutesEnum;